import React, { FC, useCallback } from "react";

import { defineMessages } from "react-intl";

import { GuideType } from "@mapmycustomers/shared/enum/guides";
import User from "@mapmycustomers/shared/types/User";

import UserFilter from "@app/component/UserFilter";
import GuidesQuickSearch from "@app/scene/onboarding/components/GuidesQuickSearch";

import styles from "./GuidesFilterBar.module.scss";
import TypeFilter from "./TypeFilter";
import UnassignedFilter from "./UnassignedFilter";

const messages = defineMessages({
  assigneeFilterTitle: {
    id: "onboarding.guides.filters.assignee.title",
    defaultMessage: "Assigned to{hasValue, select, true {: {label}} other {}}",
    description: "Title of the User filter button on the Guides page",
  },
});

export interface GuidesFilterBarProps {
  assigneeFilter: null | User["id"][];
  onAssigneeFilterChange: (value: null | User["id"][]) => void;
  onQuickFilterChange: (value: string) => void;
  onTypeFilterChange: (type: GuideType | undefined) => void;
  quickFilter: string;
  typeFilter?: GuideType;
}

const GuidesFilterBar: FC<GuidesFilterBarProps> = ({
  assigneeFilter,
  onAssigneeFilterChange,
  onQuickFilterChange,
  onTypeFilterChange,
  quickFilter,
  typeFilter,
}) => {
  const handleUnassignedFilterToggle = useCallback(
    (active: boolean) => {
      onAssigneeFilterChange(active ? null : []);
    },
    [onAssigneeFilterChange]
  );

  return (
    <div className={styles.container}>
      <div className={styles.filters}>
        <UserFilter
          onChange={onAssigneeFilterChange}
          title={messages.assigneeFilterTitle}
          value={assigneeFilter}
        />
        <UnassignedFilter
          active={assigneeFilter === null}
          onToggle={handleUnassignedFilterToggle}
        />
        <TypeFilter onChange={onTypeFilterChange} value={typeFilter} />
      </div>
      <div className={styles.quickSearch}>
        <GuidesQuickSearch onChange={onQuickFilterChange} value={quickFilter} />
      </div>
    </div>
  );
};

export default GuidesFilterBar;
